module.exports = __webpack_public_path__ + "static/media/pimienta-limon-1-copy.6215f483.png";